import {
    CREATE_REVISION_START,
    CREATE_UPDT_REVISION_SUCCESS, CREATE_UPDT_REVISION_FAIL, TAGS_PROG_BAR_STATUS,
    LOADING, SUCCESS, ERROR, INIT, CREATE_UPDT_REVISION_PHASE_CHG,
    UPDATE_REVISION_START,
    ADD_TIMEOUT_PAYLOAD,
    UPDATE_TIMEOUT_STATUS,
    CREATE_DUPLICATELINE_START,
    CREATE_DUPLICATELINE_SUCCESS,
    CREATE_DUPLICATELINE_FAIL
} from "./revTypes";




export const initialState = {
    timeOutApiPayload: [],
    error: null,
    isTimeOut: false,
    phase: INIT,

    showProgress: false,
    tagsPosted: 0,
    //  ttlTagsCount: 0
}
let updArrPkg = [];
let copySizing = [];

export const revisionReducer = (state = initialState, action) => {

    switch (action.type) {

        case CREATE_REVISION_START:
            return {
                ...state,
                phase: LOADING,
                timeOutApiPayload: [],
                isTimeOut: false,
                showProgress: true,
                tagsPosted: action.payload?.status === "START" ? 0 : state.tagsPosted
                // ttlTagsCount:action.payload?.recordsArr.length
            };

        case CREATE_UPDT_REVISION_SUCCESS:
            return {
                ...state,
                timeOutApiPayload: [],
                isTimeOut: false,
                showProgress: false,
                phase: SUCCESS,
                tagsPosted: 0,
            };

        case CREATE_UPDT_REVISION_FAIL:
            return {
                ...state,
                timeOutApiPayload: [],
                isTimeOut: false,
                error: action?.payload,
                showProgress: false,
                phase: ERROR,
                tagsPosted: 0,
            };

        case CREATE_UPDT_REVISION_PHASE_CHG:
            return {
                ...state,
                phase: action.payload,
                timeOutApiPayload: [],
                isTimeOut: false
            };

        case UPDATE_REVISION_START:
            return {
                ...state,
                phase: LOADING,
                timeOutApiPayload: [],
                isTimeOut: false,
                showProgress: true,
                tagsPosted: action.payload?.status === "START" ? 0 : state.tagsPosted
            };

        case ADD_TIMEOUT_PAYLOAD:
            let tagsItm = []
            for (const item in action.payload) {
                tagsItm = [...tagsItm, ...action.payload[item]]

            }

            updArrPkg = [...state.timeOutApiPayload, ...tagsItm];
            return {
                ...state,
                phase: ERROR,
                timeOutApiPayload: updArrPkg,
            };

        case UPDATE_TIMEOUT_STATUS:
            return {
                ...state,
                isTimeOut: action.payload
            };

        case TAGS_PROG_BAR_STATUS:
            let count = state.tagsPosted + action.payload.tagsPosted

            return {
                ...state,
                tagsPosted: count,
            };
        case CREATE_DUPLICATELINE_START:
            return {
                ...state,
                phase: LOADING,
            };
        case CREATE_DUPLICATELINE_SUCCESS:
            return {
                ...state,
                phase: SUCCESS,
                duplicateLine: [...state.duplicateLine, action.duplicateLine],
            };


        default:
            return state;


    }
}